import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=1d49eae8&"
import script from "./Blank.vue?vue&type=script&lang=js&"
export * from "./Blank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d49eae8')) {
      api.createRecord('1d49eae8', component.options)
    } else {
      api.reload('1d49eae8', component.options)
    }
    module.hot.accept("./Blank.vue?vue&type=template&id=1d49eae8&", function () {
      api.rerender('1d49eae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/Blank.vue"
export default component.exports